import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Calendar, Home as HomeIcon, Settings, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export const AdminSidebar = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = [
    { path: '/admin', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/bookings', label: 'Reservas', icon: Calendar },
    { path: '/admin/room-types', label: 'Tipos de Quartos', icon: HomeIcon },
    { path: '/admin/settings', label: 'Configurações', icon: Settings },
  ];

  return (
    <div className="w-64 bg-primary text-white min-h-screen p-6 flex flex-col" data-testid="admin-sidebar">
      <div className="mb-8">
        <h1 className="text-2xl font-display font-bold">Hotel Del Rio</h1>
        <p className="text-white/60 text-sm">Admin Panel</p>
      </div>

      <nav className="flex-1 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-white/20 text-white'
                  : 'text-white/70 hover:bg-white/10 hover:text-white'
              }`}
              data-testid={`admin-nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <Icon className="h-5 w-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <button
        onClick={logout}
        className="flex items-center gap-3 px-4 py-3 rounded-lg text-white/70 hover:bg-white/10 hover:text-white transition-colors w-full"
        data-testid="admin-logout-button"
      >
        <LogOut className="h-5 w-5" />
        <span>Sair</span>
      </button>
    </div>
  );
};
